import React, { useRef, useState } from "react";
import { Upload } from "lucide-react";
import "./CsvDropTarget.scss";

const hasFiles = (event) =>
  event.currentTarget.contains(event.target) &&
  Array.from(event.dataTransfer?.types || []).includes("Files");

const CsvDropTarget = ({ className = "", disabled = false, label, onFile, children }) => {
  const depth = useRef(0);
  const [dragging, setDragging] = useState(false);

  if (disabled) return <div className={className}>{children}</div>;

  const reset = () => {
    depth.current = 0;
    setDragging(false);
  };

  return (
    <div
      className={`${className} csv-drop-target${dragging ? " is-dragging" : ""}`}
      onDragEnter={(event) => {
        if (!hasFiles(event)) return;
        event.preventDefault();
        depth.current += 1;
        setDragging(true);
      }}
      onDragOver={(event) => {
        if (hasFiles(event)) event.preventDefault();
      }}
      onDragLeave={(event) => {
        if (!event.currentTarget.contains(event.target)) return;
        depth.current = Math.max(0, depth.current - 1);
        if (depth.current === 0) setDragging(false);
      }}
      onDrop={(event) => {
        if (!hasFiles(event)) return;
        event.preventDefault();
        reset();
        const file = event.dataTransfer.files?.[0];
        if (file) onFile(file);
      }}
    >
      {children}
      {dragging ? (
        <div className="csv-drop-target__overlay" aria-hidden="true">
          <span className="csv-drop-target__icon">
            <Upload size={22} />
          </span>
          <p>{label}</p>
        </div>
      ) : null}
    </div>
  );
};

export default CsvDropTarget;
